import React from 'react';  
import PropTypes from 'prop-types';
import styles from  './ElementImage.module.scss';
import Asset from '../Asset';
import ImageExpand from '../ImageExpand';
const ElementImage = (props) => {
       const { _id, image, imageExpand } = props;

  if (!image) {
    return null;
  }
  return (
    <div className={styles.elementImage} data-testid="ElementImage">
      <div style={{ position: 'relative' }}>
        <Asset
          _id={_id}
          imageWrapClassName="imageColorWrap"
          imageClassName={styles.image}
          fieldName="image"
          {...image}
        />
        {imageExpand && image ? <ImageExpand image={image} _id={_id} /> : null}
      </div>
    </div>
  );
};


ElementImage.propTypes = {
  _id: PropTypes.string,
  image: PropTypes.shape({
    title: PropTypes.string,
    url: PropTypes.string,
    size: PropTypes.number,
    width: PropTypes.number,
    height: PropTypes.number,
    filename: PropTypes.string,
    contentType: PropTypes.string
  }).isRequired,
  imageExpand: PropTypes.bool,
  className: PropTypes.string
};

ElementImage.defaultProps = {
  _id: '',
  imageExpand: false,
  className: ''
};

export default ElementImage;